import React from "react";
import { useNavigate } from "react-router-dom";
import { useNavbarData } from "../../../hooks/useNavbarData";
import BuddyPng from "../../../assets/PNG/HeroPassport.png";
import BuddyGif from "../../../assets/Gif/HeroPassport.gif";
import EventPng from "../../../assets/PNG/HeroEvents.png";
import EventGif from "../../../assets/Gif/HeroEvents.gif";
import WorldPng from "../../../assets/PNG/HeroEsim.png";
import WorldGif from "../../../assets/Gif/HeroEsim.gif";
import SchengenPng from "../../../assets/PNG/Schengen Checker.png";
import SchengenGif from "../../../assets/Gif/Schengen Checker.gif";
import { REGIONS, VISA_TYPES } from "./homeData/destinations";
import { POPULARITY_OPTIONS } from "./homeData/homeConstants";

export default function Hero({
  search,
  setSearch,
  region,
  setRegion,
  type,
  setType,
  popularity,
  setPopularity,
  filteredCount,
}) {
  const [activeTab, setActiveTab] = React.useState("explore");
  const [openDrop, setOpenDrop] = React.useState(null);
  const [isCompact, setIsCompact] = React.useState(false);
  const [filterPanelOpen, setFilterPanelOpen] = React.useState(false);
  const [gifPlayed, setGifPlayed] = React.useState(false);
  const [hoveredTab, setHoveredTab] = React.useState(null);
  const [gifKey, setGifKey] = React.useState(0);
  const navigate = useNavigate();
  const { data: navDynamic } = useNavbarData();

  React.useEffect(() => {
    const timer = setTimeout(() => setGifPlayed(true), 2500);
    return () => clearTimeout(timer);
  }, []);

  const tabImgMap = React.useMemo(() => {
    if (!navDynamic?.tabs) return {};
    const map = {};
    navDynamic.tabs.forEach((t) => {
      map[t.id] = {
        png: typeof t.png === "object" ? (t.png?.png || "") : (t.png || ""),
        gif: typeof t.gif === "object" ? (t.gif?.gif || "") : (t.gif || ""),
      };
    });
    return map;
  }, [navDynamic]);

  React.useEffect(() => {
    const checkWidth = () => setIsCompact(window.innerWidth < 1025);
    checkWidth();
    window.addEventListener("resize", checkWidth);
    return () => window.removeEventListener("resize", checkWidth);
  }, []);

  const handleSearchClick = () => {
    // scroll behavior removed - content should stay in place
  };

  const activeRegionLabel = REGIONS.find((item) => item.value === region)?.label || "All Regions";
  const activeTypeLabel = VISA_TYPES.find((item) => item.value === type)?.label || "All Types";
  const activePopularityLabel =
    POPULARITY_OPTIONS.find((item) => item.value === popularity)?.label || "Popularity";
  const hasFilters = region !== "All" || type !== "All" || popularity !== "All";

  const clearAll = () => {
    setRegion("All");
    setType("All");
    setPopularity("All");
    setOpenDrop(null);
  };

  React.useEffect(() => {
    const handler = () => setOpenDrop(null);
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, []);

  const tabs = [
    {
      id: "Passport Buddy",
      label: "Passport Buddy",
      to: "/Passportguide",
      png: tabImgMap["Passport Buddy"]?.png || BuddyPng,
      gif: tabImgMap["Passport Buddy"]?.gif || BuddyGif,
    },
    {
      id: "events",
      label: "Events",
      to: "/EventsPage",
      png: tabImgMap["events"]?.png || EventPng,
      gif: tabImgMap["events"]?.gif || EventGif,
    },
    {
      id: "Esim",
      label: "Esim & Connectivity",
      to: "/Esim",
      png: tabImgMap["Esim"]?.png || WorldPng,
      gif: tabImgMap["Esim"]?.gif || WorldGif,
    },
  ];

  return (
    <section className="home-hero" id="hero-section">
      <div className="home-hero__bg">
        <div className="home-hero__orb home-hero__orb--1" />
        <div className="home-hero__orb home-hero__orb--2" />
        <div className="home-hero__orb home-hero__orb--3" />
        <div className="home-hero__orb home-hero__orb--4" />
        <div className="home-hero__orb home-hero__orb--5" />
        <div className="home-hero__orb home-hero__orb--6" />
        <div className="home-hero__grid" />
      </div>

      <div className="home-hero__inner">
        {/* ═══════════════════════════════════════════════════
            MOBILE / TABLET — Card with search + filters
        ═══════════════════════════════════════════════════ */}
        {isCompact ? (
          <div className="home-compact-card">
            {/* ── Search row (search bar + toggle button) ── */}
            <div className="home-compact-card__search-row">
              <div className="home-search-wrap home-search-wrap--compact">
                <div className="home-search home-search--compact">
                  <input
                    id="hero-search"
                    name="hero-search"
                    className="home-search__input"
                    type="text"
                    placeholder="Where do you want to go?"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                  {search && (
                    <button
                      className="home-search__clear"
                      onClick={() => setSearch("")}
                      aria-label="Clear search"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                      </svg>
                    </button>
                  )}
                  <button className="home-search__btn" onClick={handleSearchClick} aria-label="Search">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="11" cy="11" r="8"></circle>
                      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                    </svg>
                  </button>
                </div>
              </div>
              <button
                className={`home-compact-card__toggle${filterPanelOpen ? " home-compact-card__toggle--open" : ""}`}
                onClick={() => setFilterPanelOpen((prev) => !prev)}
                aria-label="Toggle filters"
                aria-expanded={filterPanelOpen}
              >
                <span className="home-compact-card__toggle-line home-compact-card__toggle-line--top" />
                <span className="home-compact-card__toggle-line home-compact-card__toggle-line--mid" />
                <span className="home-compact-card__toggle-line home-compact-card__toggle-line--bot" />
                {hasFilters && (
                  <span className="home-compact-card__toggle-badge">{filteredCount}</span>
                )}
              </button>
            </div>

            {/* ── Icon tabs ── */}
            <div className="home-compact-card__tabs">
              {tabs.map((tab, i) => {
                const isHovered = hoveredTab === tab.id;
                const showGif = !gifPlayed || isHovered;
                return (
                <button
                  key={tab.id}
                  className={`home-compact-card__tab${activeTab === tab.id ? " home-compact-card__tab--active" : ""}`}
                  onClick={() => {
                    setActiveTab(tab.id);
                    if (tab.to) {
                      navigate(tab.to);
                    }
                  }}
                  onMouseEnter={() => { setHoveredTab(tab.id); setGifKey(k => k + 1); }}
                  onMouseLeave={() => setHoveredTab(null)}
                  aria-label={tab.label}
                >
                  <div className={`home-compact-card__tab-img-stack${showGif ? " home-compact-card__tab-img-stack--gif" : ""}`}>
                    <img key={`gif-${gifKey}-${tab.id}`} src={tab.gif} alt="" className="home-compact-card__tab-img home-compact-card__tab-img--gif" loading="eager" />
                    <img src={tab.png} alt={tab.label} className="home-compact-card__tab-img home-compact-card__tab-img--png" loading="lazy" />
                  </div>
                  <span className="home-compact-card__tab-label">{tab.label}</span>
                </button>
              )})}
              <button
                className={`home-compact-card__tab home-compact-card__tab--tablet-only${activeTab === "US Interview" ? " home-compact-card__tab--active" : ""}`}
                onClick={() => {
                  setActiveTab("US Interview");
                  navigate("/interview");
                }}
                onMouseEnter={() => { setHoveredTab("US Interview"); setGifKey(k => k + 1); }}
                onMouseLeave={() => setHoveredTab(null)}
                aria-label="US Interview"
                data-aos="fade-up"
                data-aos-delay={tabs.length * 80}
              >
                <div className={`home-compact-card__tab-img-stack${!gifPlayed || hoveredTab === "US Interview" ? " home-compact-card__tab-img-stack--gif" : ""}`}>
                  <img key={`gif-${gifKey}-US-Interview`} src={tabImgMap["US Interview"]?.gif || BuddyGif} alt="" className="home-compact-card__tab-img home-compact-card__tab-img--gif" loading="eager" />
                  <img src={tabImgMap["US Interview"]?.png || BuddyPng} alt="US Interview" className="home-compact-card__tab-img home-compact-card__tab-img--png" loading="lazy" />
                </div>
                <span className="home-compact-card__tab-label">US Interview</span>
              </button>
              <button
                className={`home-compact-card__tab home-compact-card__tab--tablet-only${activeTab === "Schengen" ? " home-compact-card__tab--active" : ""}`}
                onClick={() => {
                  setActiveTab("Schengen");
                  navigate("/SchenegenChecker");
                }}
                onMouseEnter={() => { setHoveredTab("Schengen"); setGifKey(k => k + 1); }}
                onMouseLeave={() => setHoveredTab(null)}
                aria-label="Schengen"
                data-aos="fade-up"
                data-aos-delay={(tabs.length + 1) * 80}
              >
                <div className={`home-compact-card__tab-img-stack${!gifPlayed || hoveredTab === "Schengen" ? " home-compact-card__tab-img-stack--gif" : ""}`}>
                  <img key={`gif-${gifKey}-Schengen`} src={tabImgMap["Schengen"]?.gif || SchengenGif} alt="" className="home-compact-card__tab-img home-compact-card__tab-img--gif" loading="eager" />
                  <img src={tabImgMap["Schengen"]?.png || SchengenPng} alt="Schengen" className="home-compact-card__tab-img home-compact-card__tab-img--png" loading="lazy" />
                </div>
                <span className="home-compact-card__tab-label">Schengen</span>
              </button>
            </div>

            {filterPanelOpen && (
              <div className="home-filter-drawer-overlay" onClick={() => setFilterPanelOpen(false)}>
                <div className="home-filter-drawer" onClick={(e) => e.stopPropagation()}>
                  <div className="home-filter-drawer__handle" />
                  <div className="home-filter-drawer__content">
                    {/* ── Filter options ── */}
                    <div className="home-compact-card__filters">
                      <div className="home-compact-card__group">
                        <span className="home-compact-card__group-label">Region</span>
                        <div className="home-compact-card__options">
                          {REGIONS.map((item) => (
                            <button
                              key={item.value}
                              className={`home-compact-card__option${region === item.value ? " home-compact-card__option--active" : ""}`}
                              onClick={() => setRegion(item.value)}
                            >
                              {item.label}
                            </button>
                          ))}
                        </div>
                      </div>

                      <div className="home-compact-card__group">
                        <span className="home-compact-card__group-label">Visa Type</span>
                        <div className="home-compact-card__options">
                          {VISA_TYPES.map((item) => (
                            <button
                              key={item.value}
                              className={`home-compact-card__option${type === item.value ? " home-compact-card__option--active" : ""}`}
                              onClick={() => setType(item.value)}
                            >
                              {item.label}
                            </button>
                          ))}
                        </div>
                      </div>

                      <div className="home-compact-card__group">
                        <span className="home-compact-card__group-label">Popularity</span>
                        <div className="home-compact-card__options">
                          {POPULARITY_OPTIONS.map((item) => (
                            <button
                              key={item.value}
                              className={`home-compact-card__option${popularity === item.value ? " home-compact-card__option--active" : ""}`}
                              onClick={() => setPopularity(item.value)}
                            >
                              {item.label}
                            </button>
                          ))}
                        </div>
                      </div>
                    </div>

                    {/* ── Action buttons ── */}
                    <div className="home-compact-card__actions">
                      <button className="home-compact-card__clear" onClick={() => { clearAll(); setFilterPanelOpen(false); }}>
                        Clear Filter
                      </button>
                      <button className="home-compact-card__apply" onClick={() => setFilterPanelOpen(false)}>
                        Apply
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : (
          <>
            {/* ═══════════════════════════════════════════════════
                DESKTOP — Original layout
            ═══════════════════════════════════════════════════ */}
            <div className="home-search-wrap" data-aos="zoom-in-up" data-aos-delay="300">
              <div className="home-search">
                <input
                  id="hero-search"
                  name="hero-search"
                  className="home-search__input"
                  type="text"
                  placeholder="Where do you want to go?"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
                {search && (
                  <button
                    className="home-search__clear"
                    onClick={() => setSearch("")}
                    aria-label="Clear search"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                  </button>
                )}
                <button className="home-search__btn" onClick={handleSearchClick} aria-label="Search">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="11" cy="11" r="8"></circle>
                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                  </svg>
                </button>
              </div>
            </div>

            <div className="home-hero__tabs" data-aos="fade-up" data-aos-delay="50">
              {tabs.map((tab) => {
                const isHovered = hoveredTab === tab.id;
                const showGif = !gifPlayed || isHovered;
                return (
                <button
                  key={tab.id}
                  className={`home-hero__tab${activeTab === tab.id ? " home-hero__tab--active" : ""}`}
                  data-tab-id={tab.id}
                  onClick={() => {
                    setActiveTab(tab.id);
                    if (tab.to) {
                      navigate(tab.to);
                    }
                  }}
                  onMouseEnter={() => { setHoveredTab(tab.id); setGifKey(k => k + 1); }}
                  onMouseLeave={() => setHoveredTab(null)}
                  aria-label={tab.label}
                >
                  <div className={`home-hero__tab-img-stack${showGif ? " home-hero__tab-img-stack--gif" : ""}`}>
                    <img key={`hero-gif-${gifKey}-${tab.id}`} src={tab.gif} alt="" className="home-hero__tab-img home-hero__tab-img--gif" loading="eager" />
                    <img src={tab.png} alt={tab.label} className="home-hero__tab-img home-hero__tab-img--png" loading="lazy" />
                  </div>
                  <span className="home-hero__tab-label">{tab.label}</span>
                </button>
              )})}
            </div>

            <div className="home-filter-bar home-filter-bar--hero" data-aos="fade-up" data-aos-delay="350">
              <div
                className="home-filter-dropdown" 
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenDrop(openDrop === "region" ? null : "region");
                }}
              >
                <button className={`home-filter-dropdown__btn${region !== "All" ? " home-filter-dropdown__btn--active" : ""}`}>
                  <span style={{ color: region !== "All" ? "white" : "#011472" }}>
    {activeRegionLabel}
  </span>
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className={`home-filter-chevron${openDrop === "region" ? " home-filter-chevron--open" : ""}`}
                  >
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </button>

                {openDrop === "region" && (
                  <div className="home-filter-dropdown__menu" onClick={(e) => e.stopPropagation()}>
                    {REGIONS.map((item) => (
                      <button 
                        key={item.value}
                        className={`home-filter-dropdown__item${region === item.value ? " home-filter-dropdown__item--active" : ""}`}
                        onClick={() => {
                          setRegion(item.value);
                          setOpenDrop(null);
                        }}
                      >
                        {item.label}
                        {region === item.value && (
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="20 6 9 17 4 12" />
                          </svg>
                        )}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              <div
                className="home-filter-dropdown"
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenDrop(openDrop === "type" ? null : "type");
                }}
              >
                <button  className={`home-filter-dropdown__btn${type !== "All" ? " home-filter-dropdown__btn--active" : ""}`}>
                  <span style={{ color: type !== "All" ? "white" : "#011472" }}>
    {activeTypeLabel}
  </span>
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className={`home-filter-chevron${openDrop === "type" ? " home-filter-chevron--open" : ""}`}
                  >
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </button>

                {openDrop === "type" && (
                  <div className="home-filter-dropdown__menu" onClick={(e) => e.stopPropagation()}>
                    {VISA_TYPES.map((item) => (
                      <button
                        key={item.value}
                        className={`home-filter-dropdown__item${type === item.value ? " home-filter-dropdown__item--active" : ""}`}
                        onClick={() => {
                          setType(item.value);
                          setOpenDrop(null);
                        }}
                      >
                        {item.label}
                        {type === item.value && (
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="20 6 9 17 4 12" />
                          </svg>
                        )}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              <div
                className="home-filter-dropdown"
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenDrop(openDrop === "popularity" ? null : "popularity");
                }}
              >
                <button className={`home-filter-dropdown__btn${popularity !== "All" ? " home-filter-dropdown__btn--active" : ""}`}>
                  <span style={{ color: popularity !== "All" ? "white" : "#011472" }}>
    {activePopularityLabel}
  </span>
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className={`home-filter-chevron${openDrop === "popularity" ? " home-filter-chevron--open" : ""}`}
                  >
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </button>

                {openDrop === "popularity" && (
                  <div className="home-filter-dropdown__menu" onClick={(e) => e.stopPropagation()}>
                    {POPULARITY_OPTIONS.map((item) => (
                      <button
                        key={item.value}
                        className={`home-filter-dropdown__item${popularity === item.value ? " home-filter-dropdown__item--active" : ""}`}
                        onClick={() => {
                          setPopularity(item.value);
                          setOpenDrop(null);
                        }}
                      >
                        {item.label}
                        {popularity === item.value && (
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="20 6 9 17 4 12" />
                          </svg>
                        )}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              {hasFilters && (
                <button className="home-filter-clear" onClick={clearAll}>
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round">
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                  </svg>
                  Clear
                </button>
              )}
            </div>
          </>
        )}
      </div>
    </section>
  );
}
